import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base.service';

import { WINDOW } from '../http/window.providers';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AVAILABLE_HOSTS } from '../constants';
import { LanguageService } from './language.service';

@Injectable()
export class TokenService extends BaseService {
    private getCookie(name: string): string | null {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop()?.split(';').shift() || null;
        }
        return null;
    }

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    localRoutes = ['127.0.0.1', 'localhost', '10.0.0.100', '192.168.40.146', 'ngrok-free'];

    /**
     * Definir o recebimento do host
     */
    _host: string = 'testecbt.tenisintegrado.com.br';
    get host(): string {
        return this._host;
    }

    set host(host: string) {
        this._host = host;
    }

    public availableHosts = AVAILABLE_HOSTS;

    get allHostsFlat(): string[] {
        const tennisHosts = [...AVAILABLE_HOSTS.tennis.confederations, ...AVAILABLE_HOSTS.tennis.federations];
        return [...tennisHosts, ...AVAILABLE_HOSTS.pickleball];
    }

    constructor(
        @Inject(WINDOW)
        private window: Window,
        private http: HttpClient,
        private languageService: LanguageService
    ) {
        super();

        if (this.getCookie('host') && this.getCookie('host') !== 'null') {
            this.host = this.getCookie('host');
        } else {
            this.host = this.localStorage.getHost() || 'testecbt.tenisintegrado.com.br';
        }
    }

    /**
     * initializeToken()
     */
    initializeToken(): Observable<any> {
        const apiToken = this.getCookie('apiToken');
        const host = this.getCookie('host');

        if (host && host !== 'null') {
            console.log('salvando host');
            this.localStorage.saveHost(host);
        }
        // if (apiToken && apiToken !== 'null') {
        //     console.log('salvando token');
        //     this.localStorage.saveToken(apiToken);
        // }
        const localToken = this.localStorage.getToken();
        const hasToken = localToken && localToken !== 'null';

        if (hasToken) {
            return of(1);
        } else {
            return this.setToken().pipe(
                map((response) => {
                    this.successCallbackApi(response);
                })
            );
        }
    }

    /**
     * setToken() - Buscar token com permissão para o host utilizado
     * Se houver testes no localhost, domínios disponíveis
     * - "testecbt.tenisintegrado.com.br"
     * - "testefct.tenisintegrado.com.br"
     * - "testefgt.tenisintegrado.com.br"
     * - "testeuy.tenisintegrado.com"
     * - "testecl.tenisintegrado.com"
     * - "testepy.tenisintegrado.com"
     * - "testeacademia.tenisintegrado.com.br"
     * - "testegnu.tenisintegrado.com.br"
     * - testefro.tenisintegrado.com.br
     */
    setToken(): Observable<any> {
        this.host = this.localRoutes.includes(this.window.location.hostname)
            ? this.host
            : this.window.location.hostname;

        // Instancia do body através de BaseService.setBody();
        let body = this.setBody();
        // Definir sistema
        body.set('system', '2');
        // Definir host
        body.set('host', this.host);
        // Definir usuário logado
        body.set('token', null);
        body.delete('language');
        // const user = this.userService.currentUser.getValue();
        // if (!!user) {
        //     body.set('userId', user.id_site);
        // }

        let response = this.http
            .post(this.urlService + this.routeAdress.route_auth_token, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    refreshToken() {
        return this.setToken().pipe(
            map((response) => {
                this.successCallbackApi(response);
                return response;
            })
        );
        // this.window.location.href = this.window.location.origin;
    }

    redirectToken(currentToken) {
        const body = this.setBody();

        body.set('token', currentToken);

        // PARA LOCALHOST APENAS:
        // HOST ATUALIZADO LOCALMENTE
        // this.host = host;
        // body.set('host', this.host);

        return this.http.post(this.urlService + this.routeAdress.route_auth_redirect_token, body.toString()).pipe(
            map((response) => this.successCallbackApi(response)),
            catchError(this.serviceError)
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.localStorage.saveToken(response.token);
        this.localStorage.saveHost(this.host);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }
}
